import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ceoImg from "../../assets/deepika.png"; 
import dineshImg from "../../assets/dinesh.png";
import vijiImg from "../../assets/viji.png";
import life1 from "../../assets/life1.png"; 
import life2 from "../../assets/life2.png";
import life3 from "../../assets/life3.png";
import life4 from "../../assets/life4.png";
import partner1 from "../../assets/partner1.png";
import partner2 from "../../assets/partner2.png";
import partner3 from "../../assets/partner3.png";
import partner4 from "../../assets/partner4.png";
import partner5 from "../../assets/partner5.png";
import partner6 from "../../assets/partner6.jpeg"; 
import partner7 from "../../assets/partner7.jpeg";
import partner8 from "../../assets/partner8.jpeg";
import partner9 from "../../assets/partner9.jpeg";
import partner10 from "../../assets/partner10.jpeg";
import partner11 from "../../assets/partner11.jpeg";
import partner12 from "../../assets/partner12.jpeg";
import partner13 from "../../assets/partner13.jpeg";
import partner14 from "../../assets/partner14.jpeg";
import partner15 from "../../assets/partner15.jpeg";
import partner16 from "../../assets/partner23.jpeg";
import partner17 from "../../assets/partner17.jpeg";
import partner18 from "../../assets/partner18.jpeg";
import partner19 from "../../assets/partner19.jpeg";
import partner20 from "../../assets/partner20.jpeg";
import partner21 from "../../assets/partner21.jpeg";
import partner22 from "../../assets/partner22.jpeg";






import { ArrowLeft, ArrowRight } from "lucide-react";

// Team Members
const teamMembers = [
  { name: "Dr. Deepika", role: "Founder & CEO", subtitle: "Healing & Transformation", image: ceoImg },
  { name: "Dinesh Natarajan", role: "Partner", subtitle: "Leadership & Strategy", image: dineshImg },
  { name: "Viji Nair", role: "Head of Operations", subtitle: "Empowering Teams, Driving Growth", image: vijiImg },
];

// Life at Butterfly
const lifeAtButterfly = [
  { image: life1, title: "Our Values", description: "We lead with empathy, act with integrity, and create with heart." },
  { image: life2, title: "Our Life Style", description: "Balance is a perk! Creative spaces, calm minds, and joyful days." },
  { image: life3, title: "Our Experience", description: "Every role makes a real difference in careers, homes, and lives." },
  { image: life4, title: "Our Team", description: "A close-knit crew of dreamers, doers, and believers lifting each other up." },
];

const partnerLogos = [partner1, partner2, partner3, partner4, partner5, partner6, partner7, partner8, partner9, partner10, partner11, partner12, partner13, partner14, partner15, partner16, partner17, partner18, partner19, partner20, partner21, partner22];

const TeamCarousel = () => {
  const [current, setCurrent] = useState(0);

  const nextMember = () => setCurrent((prev) => (prev + 1) % teamMembers.length);
  const prevMember = () => setCurrent((prev) => (prev === 0 ? teamMembers.length - 1 : prev - 1));

  const prevIndex = current === 0 ? teamMembers.length - 1 : current - 1;
  const nextIndex = (current + 1) % teamMembers.length;

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="text-center px-6 md:px-12 py-12">
      {/* Life at Butterfly */}
      <section data-aos="fade-down-right">
        <h2 className="text-2xl md:text-3xl font-bold mb-8">LIFE AT BUTTERFLY</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {lifeAtButterfly.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <img src={item.image} alt={item.title} className="w-32 h-32 md:w-40 md:h-40 object-cover mb-4" />
              <h3 className="font-semibold text-base md:text-lg">{item.title}</h3>
              <p className="text-[#204356] text-sm mt-2 px-2 md:px-0">{item.description}</p>
            </div>
          ))}
        </div>
      </section>

{/* Team Section */}
<section data-aos="zoom-in" className="py-16 px-4 md:px-12">
  <h2 className="text-3xl font-bold text-center mb-12">OUR TEAM</h2>

  <div className="flex flex-col md:flex-row items-center justify-center gap-10 md:gap-20">
    {/* Previous member - hidden on mobile */}
    <div className="hidden md:flex flex-col items-center w-36 transition-transform duration-300 hover:scale-110 cursor-pointer"
      onClick={() => setCurrent(prevIndex)}>
      <img
        src={teamMembers[prevIndex].image}
        alt={teamMembers[prevIndex].name}
        className="w-24 h-24 rounded-full object-cover shadow-md"
      />
      <p className="mt-3 text-sm font-medium text-gray-700 text-center">
        {teamMembers[prevIndex].name}
      </p>
    </div>

    {/* Current member */}
    <div className="w-full sm:w-80 md:w-96 lg:w-[600px] xl:w-[500px] bg-white shadow-lg rounded-xl p-6 md:p-8 flex flex-col items-center">
      {/* Top Content */}
      <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
        {/* Image */}
        <div className="flex-shrink-0">
          <img
            src={teamMembers[current].image}
            alt={teamMembers[current].name}
            className="w-36 h-36 md:w-44 md:h-44 object-cover rounded-sm shadow-md"
          />
        </div>

        {/* Text */}
        <div className="text-center md:text-left">
          <h3 className="font-semibold text-xl md:text-2xl text-gray-800">
            {teamMembers[current].name}
          </h3>
          <p className="text-gray-600 text-sm md:text-base mt-1">
            {teamMembers[current].role}
          </p>
        </div>
      </div>

      {/* Bottom Subtitle */}
      <p className="text-teal-500 text-sm md:text-base italic mt-4 md:mt-6 text-center">
        {teamMembers[current].subtitle}
      </p>
    </div>

    {/* Next member - hidden on mobile */}
    <div
      className="hidden md:flex flex-col items-center w-36 transition-transform duration-300 hover:scale-110 cursor-pointer"
      onClick={() => setCurrent(nextIndex)}
    >
      <img
        src={teamMembers[nextIndex].image}
        alt={teamMembers[nextIndex].name}
        className="w-24 h-24 rounded-full object-cover shadow-md"
      />
      <p className="mt-3 text-sm font-medium text-gray-700 text-center">
        {teamMembers[nextIndex].name}
      </p>
    </div>
  </div>

  {/* Navigation buttons */}
  <div className="flex justify-center space-x-4 mt-8">
    <button
      onClick={prevMember}
      className="w-12 h-12 rounded-full border border-teal-500 flex items-center justify-center text-teal-500 hover:bg-teal-500 hover:text-white transition"
    >
      <ArrowLeft size={20} />
    </button>
    <button
      onClick={nextMember}
      className="w-12 h-12 rounded-full border border-teal-500 flex items-center justify-center text-teal-500 hover:bg-teal-500 hover:text-white transition"
    >
      <ArrowRight size={20} />
    </button>
  </div>
</section>



      {/* Partners */}
      <section data-aos="fade-right" className="bg-white pt-10 text-center">
        <h2 className="text-3xl font-bold text-center mb-12">OUR PARTNERS</h2>
        <div className="overflow-hidden relative rounded-lg mt-4">
          <div className="flex w-max animate-scrollLeft hover:[animation-play-state:paused] space-x-6 md:space-x-12">
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <img key={index} src={logo} alt={`Partner Logo ${index}`} className="h-12 md:h-20 w-auto transition duration-300" />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamCarousel;
